var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 38,
    viewBox: "0 0 71 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.3987 0H28.3222C27.4491 0 26.7403 0.873162 26.7403 1.95239V29.2893C26.7403 30.3686 27.4491 31.2417 28.3222 31.2417H44.1416C45.0147 31.2417 45.7235 30.3686 45.7235 29.2893V7.80956L39.3987 0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.617 29.9914H27.8496V1.48438H38.7878V9.12978H44.617V29.9914Z",
    fill: "#353A84"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.617 29.8762H27.8496V1.3692H38.7878V9.01111H44.617V29.8762Z",
    fill: "#FF7373"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5613 20.3692C32.5727 20.3692 33.0769 20.8896 33.0769 21.9339C33.0769 22.9852 32.564 23.5126 31.5469 23.5126H30.4461V25.5174H29.7978V20.3692H31.5613ZM30.449 22.842H31.5065C31.8264 22.842 32.0598 22.7687 32.2096 22.6255C32.3537 22.4823 32.4286 22.2517 32.4286 21.9339C32.4286 21.6161 32.3508 21.3856 32.2038 21.2563C32.054 21.1131 31.8235 21.0398 31.5065 21.0398H30.449V22.842ZM35.2265 20.3692C35.9094 20.3692 36.4281 20.5997 36.7854 21.0677C37.1197 21.5008 37.2839 22.126 37.2839 22.9433C37.2839 23.7501 37.111 24.3788 36.771 24.8258C36.4137 25.2868 35.8979 25.5174 35.2121 25.5174H33.6763V20.3692H35.2265ZM34.3275 24.8468H35.094C35.6299 24.8468 36.0276 24.6896 36.2783 24.3788C36.5232 24.0679 36.6471 23.5929 36.6471 22.9433C36.6471 22.2797 36.5232 21.8047 36.284 21.5008C36.0333 21.19 35.6415 21.0398 35.1055 21.0398H34.3275V24.8468ZM40.8282 20.3692V21.0398H38.5921V22.5381H40.7042V23.2087H38.5921V25.5174H37.9438V20.3692H40.8282Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.dfa64f90384df1167c06acdd5e92368a.svg";
export { ForwardRef as ReactComponent };